// extracted by mini-css-extract-plugin
module.exports = {"podcastQuestion":"index-module--podcastQuestion--l2--i"};